import { Stack, TextField, PrimaryButton } from '@fluentui/react';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { usePromise } from '../../../../Common/hooks/usePromise';
import { resetFileHash } from '../../../../AGSS/api/AGSSApi';
import { DefaultLoadingHubButton } from '../../../../HubLayout/components/Utilities/DefaultLoadingHubButton';
import { JsonResult } from '../../../../HubLayout/components/Utilities/JsonResult';
import { ThemeContext } from '../../../../HubLayout/models/ThemeContext';
import { getThemeFromString } from '../../../../Common/util/localStorageUtils';

interface IResetFileHashProps {}

export const ResetFileHash: React.FC<IResetFileHashProps> = (
    props: IResetFileHashProps
) => {
    const themeContext = useContext(ThemeContext);
    const theme = getThemeFromString(themeContext.themeName);
    const [hashValue, setHashValue] = useState<string>('');
    const [envValue, setEnvValue] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const stackTokens = { childrenGap: 16 };

    const handleHashChange = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string | undefined
    ) => {
        setHashValue(newValue ?? '');
    };

    const handleEnvChange = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string | undefined
    ) => {
        setEnvValue(newValue ?? '');
    };

    const resetFileHashCallback = useCallback(async () => {
        if (hashValue && envValue) {
            const result = await resetFileHash(hashValue, envValue);
            setIsLoading(false);
            return result;
        }
    }, [hashValue, envValue]);

    const [result, error, isLoaded, start, cancel] = usePromise(
        resetFileHashCallback,
        false
    );

    const handleResetHashClick = () => {
        setIsLoading(true);
        start();
    };

    return (
        <Stack tokens={stackTokens}>
            <div
                style={{
                    padding: '12px',
                    backgroundColor: theme.palette.white,
                    borderRadius: '4px',
                    border: `1px solid ${theme.palette.neutralTertiaryAlt}`,
                }}
            >
                <TextField
                    label="Hash"
                    placeholder="Enter the hash value"
                    value={hashValue}
                    onChange={handleHashChange}
                    borderless
                />
            </div>
            <div
                style={{
                    padding: '12px',
                    backgroundColor: theme.palette.white,
                    borderRadius: '4px',
                    border: `1px solid ${theme.palette.neutralTertiaryAlt}`,
                }}
            >
                <TextField
                    label="Environment"
                    placeholder="Enter the environment"
                    value={envValue}
                    onChange={handleEnvChange}
                    borderless
                />
            </div>

            <Stack horizontal tokens={{ childrenGap: 12 }}>
                <PrimaryButton
                    text="Reset File Hash"
                    iconProps={{ iconName: 'Refresh' }}
                    onClick={handleResetHashClick}
                    disabled={isLoading || !hashValue || !envValue}
                />
            </Stack>

            <JsonResult data={result} />
        </Stack>
    );
};
